import {Component, OnDestroy, OnInit} from '@angular/core';
import {LeagueService} from '@core/services/league.service';
import {AppLeague} from '@shared/models/league';
import {User} from '@shared/models/user';
import {LayoutService} from '@utils/services/layout/layout.service';
import {Subscription} from 'rxjs';
import {EntityType} from '@lib/models/entity/entity-type';
import {FollowService} from '@core/services/follow/follow.service';
import {StateService} from '@core/services/state.service';
import {SnackbarService} from '@core/services/snackbar.service';
import {AnalyticsService} from '@utils/services/analytics/analytics.service';
import {UserService} from '@core/services/user.service';
import { UrlService } from '@utils/services/url/url.service';

@Component({
  selector: 'app-league-start-page',
  templateUrl: './league-start-page.component.html',
  styleUrls: [
    './league-start-page.component.scss',
    '../../../../shared/styles/entity-start-page.component.scss'
  ]
})
export class LeagueStartPageComponent implements OnInit, OnDestroy {

  public stateLink: string = null;
  public isFollowed = false;
  public league: AppLeague;
  public stateName: string;
  public showId = !StateService.isProd;
  private currentUser: User;
  private user$: Subscription;

  constructor( public layoutService: LayoutService,
               public leagueService: LeagueService,
               public followService: FollowService,
               public snackBarService: SnackbarService,
               private userService: UserService) { }

  public async ngOnInit() {
    this.league = this.leagueService.currentLeague;
    AnalyticsService.currentEntity = this.league.getAsEntity();
    this.stateName = this.league.getUIStateName();
    if (!this.stateName) {
      this.stateName = this.league.getUICountryName();
    }
    this.user$ = this.userService.currentUserSubject.subscribe(user => {
      this.currentUser = user;
      this.updateFollowStatus();
    });
    if (this.league.ui_names?.state_name) {
      this.stateLink = UrlService.Web + '/' + this.league.ui_names.state_name.toLowerCase();
    }
  }

  public ngOnDestroy() {
    AnalyticsService.currentEntity = null;
    this.user$?.unsubscribe();
    this.updateFollowStatus();
  }

  public async toggleFollow() {
    const success = await this.followService.toggleFollow(!this.isFollowed, EntityType.League, this.league.name, this.league.id);
    if (success) {
      this.updateFollowStatus();
    }
  }

  private updateFollowStatus() {
    this.isFollowed = this.followService.userFollows(EntityType.League, this.league.id)
  }

  public copyEntityId() {
    navigator.clipboard.writeText(this.league.id).then(() => {
      this.snackBarService.showSimpleSnackbar('ID wurde kopiert');
    });
  }
}
